

const ItemDetails=({item,handleDetails})=>{

const handleClick=()=>{
    handleDetails(curr=>!curr)
}
    return(
        <div className="details">
            <h2>Item details</h2>
            <label><strong>Fulfilled: </strong>
                <input type="checkbox" checked={item.fulfilled} disabled />  
            </label>
            <p><strong>Title: </strong>{item.title}</p>
            <p><strong>Created at: </strong>{new Date(item.date).toLocaleDateString("cs-CZ")+", "+new Date(item.date).toLocaleTimeString("cs-CZ")}</p>
            <p><strong>Details: </strong>{item.details}</p> 
            <button onClick={handleClick}>Close</button>
        </div>
    )
}

export default ItemDetails